const localHostnames = ["localhost", "127.0.0.1"];

const getRuntimeUrl = (envUrl) => {
  if (!envUrl || typeof window === "undefined") return envUrl;

  const { hostname } = window.location;

  if (!localHostnames.includes(hostname)) return envUrl;

  try {
    const url = new URL(envUrl);
    url.hostname = hostname;
    return url.toString();
  } catch (e) {
    return envUrl;
  }
};

export const rootUrl = getRuntimeUrl(process.env.REACT_APP_ROOT_URL);
export const apiUrl = getRuntimeUrl(process.env.REACT_APP_API_URL);
